'use client';

import { useLocale } from 'next-intl';
import { useRouter, usePathname } from '@/i18n/navigation';
import { useI18n } from '@/i18n';

export function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-1 p-1 rounded-lg bg-muted">
      <button
        onClick={() => router.replace(pathname, { locale: 'en' })}
        className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
          locale === 'en'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        {t.languageSwitcher.en}
      </button>
      <button
        onClick={() => router.replace(pathname, { locale: 'ar' })}
        className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
          locale === 'ar'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        {t.languageSwitcher.ar}
      </button>
    </div>
  );
}

export function LanguageSwitcherCompact() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useI18n();

  return (
    <button
      onClick={() => router.replace(pathname, { locale: locale === 'en' ? 'ar' : 'en' })}
      className="w-10 h-10 flex items-center justify-center rounded-lg bg-muted text-sm text-muted-foreground hover:text-foreground transition-colors"
    >
      {locale === 'en' ? t.languageSwitcher.ar : t.languageSwitcher.en}
    </button>
  );
}

export function LanguageSwitcherIcon() {
  return <LanguageSwitcher />;
}
